<template lang="pug">
  #app
    h1.md-display-1 鶴イベペースメーカー「ツルメ」
    info
    #buttons
      how-to-use
      reset
    ema-input
    #rewards
      reward(v-for='reward in rewards', :index='reward.id', :key='reward.id')
</template>

<script>
import Info from './components/Info'
import HowToUse from './components/HowToUse'
import Reset from './components/Reset'
import EmaInput from './components/EmaInput'
import Reward from './components/Reward'

export default {
  computed: {
    rewards () {
      return this.$store.state.rewards
    }
  },
  components: {
    Info,
    HowToUse,
    Reset,
    EmaInput,
    Reward
  }
}
</script>

<style lang="stylus">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#buttons
  display: flex
  justify-content: center


#rewards
  display: flex
  flex-flow: wrap
  width: 75vw
  margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/App.vue